import AvailabilityGaugeChart from './AvailabilityGaugeChart'

import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';

import GaugeChart from 'react-gauge-chart';
import PeriodWithoutCustom from '../../../../helpers/PeriodWithoutCustom';
import Period from '../../../../helpers/Period';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import highchartsMore from "highcharts/highcharts-more.js";
import solidGauge from "highcharts/modules/solid-gauge.js";
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

// Material components
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import DevicesIcon from '@material-ui/icons/Devices';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import RefreshIcon from '@material-ui/icons/Refresh';
import TabletMacIcon from '@material-ui/icons/TabletMac';
import WarningSharpIcon from '@material-ui/icons/WarningSharp';
import CircularProgress from '@material-ui/core/CircularProgress';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import InfoIcon from '@material-ui/icons/Info';
import Switch from '@material-ui/core/Switch';
import RemoveIcon from '@material-ui/icons/Remove';
import UpdateIcon from '@material-ui/icons/Update';
import Avatar from '@material-ui/core/Avatar';
import HelpIcon from '@material-ui/icons/Help';

import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Tooltip from '@material-ui/core/Tooltip';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';

import { Doughnut } from 'react-chartjs-2';
import PerfectScrollbar from 'react-perfect-scrollbar';

// Palette
import palette from 'theme/palette';


// Component styles
import styles from './styles';
import { Paper } from '@material-ui/core';
import {api_host} from '../../../../common/globals/constants'

import moment from 'moment-timezone'
import 'moment/locale/es'
moment.locale('es')

const REFRESH_TIME = 300000

class AvailabilityGauge extends Component {
    constructor(props) {
        
        super(props);
        this.handleAvailabilityGaugeChartClick = this.handleAvailabilityGaugeChartClick.bind(this);
        var real=false
        if(typeof(this.props.real)!=="undefined"){
            real=true
        };
        var statePeriod = {};
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.handleNextStepClick = this.handleNextStepClick.bind(this);
        this.handleNextNodeClick = this.handleNextNodeClick.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.handleFirstInfo = this.handleFirstInfo.bind(this);
        this.handleDateMoment = this.handleDateMoment.bind(this);

        if(props.period === 'c' && props.real==true) {
            var date = props.statePeriodAvailaGaugeReal
            const begin=(moment(date.startDate)._d)
            const final= (moment(date.endDate)._d)
            statePeriod ={startDate: begin,endDate: final,key: "selection"}
           
        }

        if(props.period === 'c' && props.online==true) {
            var date = props.statePeriodAvailaGauge
            const begin=(moment(date.startDate)._d)
            const final= (moment(date.endDate)._d)
            statePeriod ={startDate: begin,endDate: final,key: "selection"}
           
        }

        this.state = {
            typeGraph: 0,
            period: this.props.period,
            step: 0,
            node: 0,
            isForStep: false,
            isForNode: true,
            nameStep: null,
            namePeriod: null,
            x: null,
            y: null,
            isLastEvent: false,
            objetive: this.props.match.params.objetivo_id,
            statePeriod: statePeriod,
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            extendEl: null,
            nameGraph: [' Hora', ' Día', ' Semana', ' Custom', ' 3 Horas', ' 3 Días'],
            namePeriodPorlet: ['Última Hora', 'Último Día', 'Última Semana', 'Custom', 'Últimas 3 Horas', 'Últimos 3 Días'],
            typePeriod: this.props.typePeriod,
            nameNodo:"Seleccione Nodo",
            //Nodos:props.params.location.state.fromObjective.Nodos,
            settingsEl: null,
            isRefresh: false,
            isInfo: null,
            checkedA: props.automaticUpdate,
            date: new Date(),
            dateMoment: (moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, h:mm:ss a")),
            real:real,
            intervalId: null
        };
    }

    componentWillUnmount() {
       clearInterval(this.state.intervalId);
    }
    
    tick() {
        if(this.state.checkedA===true){
            this.setState({
                date: new Date(),
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("dddd, DD/MM/YYYY, h:mm:ss a"))
            });
        }
    }

    handleAvailabilityGaugeChartClick() {
        this.setState({
            typeGraph: 0,
            isForStep: false,
            isForNode: false,
            isLastEvent: false,
            nameNodo:"Seleccione Nodo",
            responseTimeGraphEl: null,
            isRefresh: false
        });
    }

    

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        const {real} =  this.state;
        if (real == true) {
            sessionStorage.setItem("availaGaugeRealSession",JSON.stringify({'nextPeriod':nextPeriod,'statePeriod':statePeriod}))
        }else if (real == false) {
            sessionStorage.setItem("availaGaugeSession",JSON.stringify({'nextPeriod':nextPeriod,'statePeriod':statePeriod}))
        }
        
        if (nextPeriod === 'hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                namePeriod: 'Rango: última hora',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: '3h',
                typePeriod: 4,
                namePeriod: 'Rango: últimas 3 horas',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: 'Rango: último día',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 5,
                namePeriod: 'Rango: últimos 3 días',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'semana') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 2,
                namePeriod: 'Rango: última semana',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'custom') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "c",
                typePeriod: 3,
                namePeriod: 'Rango: ' + statePeriod.startDate.toISOString().substring(0, 10) + ' a ' + statePeriod.endDate.toISOString().substring(0, 10),
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
                isRefresh: false
            });
        }
    }

    handleNextStepClick(propsStep, nextStep) {
        const prevPeriod = propsStep.period
        const prevTypeGraph = propsStep.typeGraph
        const newStep = nextStep
        if (propsStep.step !== newStep) {
            this.setState({
                typeGraph: prevTypeGraph,
                period: prevPeriod,
                step: newStep,
                isLastEvent: false,
                isRefresh: false
            })
        }
    }
    /*handleNextNodeClick(propsNode, nextNode) {
        const prevPeriod = propsNode.period
        const prevTypeGraph = propsNode.typeGraph
        const newNode = nextNode
        if (propsNode.node !== newNode) {
            this.setState({
                typeGraph: prevTypeGraph,
                period: prevPeriod,
                node: newNode,
                isLastEvent: false
            })
        }
    }*/

    handleNextNodeClick = event => {
        const nameNodo=event.currentTarget.name
        const newNode = event.currentTarget.id
        if (this.state.node !== newNode) {
            this.setState({
                node: newNode,
                isLastEvent: false,
                extendEl: null,
                nameNodo:nameNodo,
                isRefresh: false
            })
        }
   
    }

    handleRefresh = event => {
        this.setState({
            isRefresh: true,
            settingsEl: null,
        })
    }

    handleInfo(props, step) {
        let oldDate = new Date(props.x)
        if (isNaN(oldDate)) {
            this.setState({
                nameStep: step,
                x: props.x,
                y: props.y
            })
        } else {
            let year = oldDate.getUTCFullYear()
            let month = oldDate.getUTCMonth()
            let day = oldDate.getUTCDate()
            let hours = oldDate.getUTCHours()
            let minutes = oldDate.getUTCMinutes()
            let seconds = oldDate.getUTCSeconds()
            let newDate = new Date(year, (month), day, hours, minutes, seconds)
            this.setState({
                nameStep: step,
                x: newDate.toLocaleString(),
                y: props.y
            })
        }
    }

    handleFirstInfo(props) {
        let oldDate = new Date(props.x)
        if (isNaN(oldDate)) {
            if (!this.state.isLastEvent && props.name !== null) {
                this.setState({
                    nameStep: props.name,
                    namePeriod: props.namePeriod,
                    x: props.x,
                    y: props.y,
                    isLastEvent: true
                })
            }
        } else {
            let year = oldDate.getUTCFullYear()
            let month = oldDate.getUTCMonth()
            let day = oldDate.getUTCDate()
            let hours = oldDate.getUTCHours()
            let minutes = oldDate.getUTCMinutes()
            let seconds = oldDate.getUTCSeconds()
            let newDate = new Date(year, (month), day, hours, minutes, seconds)
            if (!this.state.isLastEvent && props.name !== null) {
                this.setState({
                    nameStep: props.name,
                    x: newDate.toLocaleString(),
                    y: props.y,
                    namePeriod: props.namePeriod,
                    isLastEvent: true
                })
            }
        }
    }

    handleShowResponseTimeGraph = event => {
        this.setState({
            responseTimeGraphEl: event.currentTarget
        });
    };
    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    handleCloseResponseTimeGraph = () => {
        this.setState({
            responseTimeGraphEl: null
        });
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handleShowExtend = event => {
        this.setState({
            extendEl: event.currentTarget
        });
    };
    handleCloseExtend = () => {
        this.setState({
            extendEl: null
        });
    };
    handleChange = name=> event => {
        if (event.target.checked) {
            clearInterval(this.state.intervalId)
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({intervalId: newIntervalId})
        }
        this.setState({ 
            checkedA: event.target.checked 
        });
      };

    handleDateMoment(props) {
        this.setState({
            dateMoment:props,
            isRefresh: false
        })
    }
    componentDidMount() {
        if (this.props.automaticUpdate) {
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({intervalId: newIntervalId})
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.automaticUpdate !== this.props.automaticUpdate && prevProps.refreshTime === this.props.refreshTime) {
            if (this.props.automaticUpdate) {
                clearInterval(this.state.intervalId)
                const newIntervalId = setInterval(
                    () => this.tick(),
                    this.props.refreshTime || REFRESH_TIME
                );
                this.setState({
                    intervalId: newIntervalId,
                    checkedA: this.props.automaticUpdate
                })
            } else {
                this.setState({checkedA: this.props.automaticUpdate})
                clearInterval(this.state.intervalId)
            }
        }
        if (prevProps.refreshTime !== this.props.refreshTime && this.state.checkedA) {
            clearInterval(this.state.intervalId)
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({
                intervalId: newIntervalId,
            })
        }
        
        if (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) {
            this.setState({
                typeGraph: 0,
                period: this.state.period,
                step: this.state.step,
                isForStep: false,
                nameStep: null,
                x: null,
                y: null,
                isLastEvent: false,
                objetive: this.props.match.params.objetivo_id,
                periodEl: null
            })
        }
    }

    render() {
        const { classes, className, location } = this.props;
        const { typeGraph, period, isForStep, step, x, y, nameStep, statePeriod, isStatePeriod, 
            namePeriod, node, isForNode, responseTimeGraphEl, periodEl, nameGraph, namePeriodPorlet,
            typePeriod, extendEl, settingsEl, isRefresh, isInfo, detalleGraph, date, dateMoment, real} = this.state;
        const { fromObjective } = this.props.location.state
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)

        let buttonAvailabilityGaugeChart;
 
        const showExtendEl = Boolean(extendEl);

        buttonAvailabilityGaugeChart = <AvailabilityGaugeChartButton onClick={this.handleAvailabilityGaugeChartClick} />;
 
        const showResponseTimeGraphEl = Boolean(responseTimeGraphEl);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);
        const showPeriodEl = Boolean(periodEl);
        const rootClassName = classNames(classes.root, className);
        const divStyle = {
            top: '32%',left: '21%', width:'500px'
          };
          const divStylePop = {
            top: '57%',left: '48%'
          };
          
        return (

            <Portlet
                    /*  {...rest} */
                    className={rootClassName}
                >
                    <PortletHeader className={classes.header}
                    >
                        <PortletLabel
                            /*  icon={<DevicesIcon />} */
                            variant="h6"
                            title={this.props.title + nameGraph[typePeriod]}
                        />

                        <PortletToolbar>
                            <IconButton
                                //className={classes.refreshButton}
                                //variant="text"
                                onClick={this.handleShowSettings}
                            >
                                <SettingsOutlinedIcon />
                                
                            </IconButton>
                            <Popover
                                    anchorEl={settingsEl}
                                    onClose={this.handleCloseSettings}
                                    open={showSettingsEl}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                      }}
                                      transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                      }}
                                    >
                                    <IconButton
                                        className={classes.refreshButton}
                                        variant="text"
                                        onClick={this.handleRefresh}
                                        onClose={this.handleCloseSettings}
                                    >
                                        <div>
                                            <RefreshIcon color="infoIcon" /><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>Actualizar</Typography>
                                        </div>
                                    </IconButton>
                                    <IconButton
                                        onClick={this.handleShowIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                    >
                                        <div>
                                            <HelpIcon color="infoIcon"/><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>Información</Typography>
                                        </div>
                                    </IconButton>
                                     <Popover
                                        anchorEl={isInfo}
                                        open={showIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                        >
                                        <PortletContent variant="h4" style={{fontSize:'16px', color:'#66788A'}}>
                                            {<div>
                                                <div>
                                                    <Typography variant="h4" style={{fontSize:'20px',float:'left', paddingLeft:'5px', color:'#55BF3B'}}>
                                                        <h5><RemoveIcon color={'#55BF3B'}/>SLA disponibilidad ok: {sla_disponibilidad_ok}%</h5>
                                                    </Typography>
                                                </div>
                                                <div>
                                                    <Typography variant="h4" style={{fontSize:'20px',float:'left', paddingLeft:'5px', color:'#DF5353'}}>
                                                        <h5><RemoveIcon color={'#DF5353'}/>SLA disponibilidad error: {sla_disponibilidad_error}%</h5>
                                                    </Typography>    
                                                </div>
                                            </div>}
                                        </PortletContent>
                                    </Popover>
                                    <Tooltip title="Actualización Automatica">
                                        <div style={{textAlign:"center"}}>
                                            <Switch
                                                checked={this.state.checkedA}
                                                onChange={this.handleChange('checkedA')}
                                                value="checkedA"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                color='primary'
                                            />
                                        </div>
                                    </Tooltip>
                                </Popover>
                            
                            
                            {/*<Button
                                color="primary"
                                variant="text"
                                onClick={this.handleShowResponseTimeGraph}
                                >
                                Gráficos <ArrowRightIcon />
                            </Button>*/}
                            <Popover
                                anchorEl={responseTimeGraphEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center'
                                }}
                                onClose={this.handleCloseResponseTimeGraph}
                                open={showResponseTimeGraphEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center'
                                }}>
                                <div>
                                    {buttonAvailabilityGaugeChart}
                                </div>

                            </Popover>
                        </PortletToolbar>
                    </PortletHeader>
                    <PortletContent className={classes.content}>
                                {period == 'c' ?                                    
                                    <div >
                                        <Typography   color="textSecondary" gutterBottom>
                                            desde {statePeriod.startDate.toISOString().substring(0, 10)} hasta {statePeriod.endDate.toISOString().substring(0, 10)}
                                        </Typography>
                                    </div>
                                : null}
                                <Graph
                                    typeGraph={typeGraph}
                                    period={period}
                                    step={step}
                                    node={node}
                                    onInfo={this.handleInfo}
                                    onFirstInfo={this.handleFirstInfo}
                                    statePeriod={statePeriod}
                                    isStatePeriod={isStatePeriod}
                                    isRefresh={isRefresh} 
                                    date={date}
                                    real={real}
                                    onDateMoment={this.handleDateMoment}/>
                                <div style={{float:"right", marginTop:"5%"}}>
                                     <div style={{
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                        {/* <Typography >
                                        Última actualización:
                                        </Typography> */}
                                        
                                        <Avatar variant="rounded" className={classes.rounded}>
                                        <UpdateIcon /> 
                                        </Avatar>
                                        <Typography  className={classes.updateTime}   >
                                                &nbsp; Última actualización: {dateMoment} 
                                        </Typography>
                                        
                                    </div>
                                </div>
           
               
                    </PortletContent>
                    
                    <PortletFooter className={classes.portletFooter}>
                        <Button  style={{fontSize:'15px',float:'left', color:'#66788A'}} onClick={this.handleShowPeriod}>
                            {namePeriodPorlet[typePeriod]}<ArrowDropDownIcon />
                        </Button>
                        <Popover
                            anchorEl={periodEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleClosePeriod}
                            open={showPeriodEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <Period onClick={this.handlePeriodClick} period={period} typeGraph={typeGraph}/>
                        </Popover>

                        {/*<Button
                            color="primary"
                            variant="text"
                            onClick={this.handleShowExtend}
                        >
                            {this.state.nameNodo} <ArrowRightIcon />
                        </Button>*/}
                        
                        <Popover
                            anchorEl={extendEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleCloseExtend}
                            open={showExtendEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <div>
                                {isForNode ? <div className="row1">
                                                <List component="div">
                                                    {Object.values(location.state.fromObjective.Nodos).map(i => (
                                                        
                                                        <ListItem
                                                            className={classes.listItem}
                                                            component="div"
                                                        >
                                                            <ListItemIcon
                                                                className={classes.listItemIcon}
                                                            />
                                                           <Button id={i.id_nodo} name={i.nodo} onClick={(event) => this.handleNextNodeClick(event)}>{i.nodo}</Button> 
                                                        </ListItem>))}
                                                </List>
                                            </div> : <div> No hay información que mostrar</div>}
                            </div>
                        </Popover>
                        
                    </PortletFooter>
                </Portlet>
        )
    }
}

function Graph(props) {
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {
        return <AvailabilityGaugeChart params={props} />;
    }

}

function AvailabilityGaugeChartButton(props) {
    return (
        <Button onClick={props.onClick}>
            General
      </Button>
    );
}

export default
    compose(withRouter, withStyles(styles))(AvailabilityGauge);